import { render, staticRenderFns } from "./NusCodesPage.vue?vue&type=template&id=4b9a73c0&scoped=true&"
import script from "./NusCodesPage.vue?vue&type=script&lang=ts&"
export * from "./NusCodesPage.vue?vue&type=script&lang=ts&"
import style0 from "./NusCodesPage.vue?vue&type=style&index=0&id=4b9a73c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9a73c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VSpacer,VTextField,VTooltip})
